export default (initialState = {}) => {
  return () => {
    return {
      credit_cycle: 7,
      credit_limit: 1,
      credit_eligibility: { name: "Eligible", code: "E", value: true },
      is_advance_required: false,
      ...initialState,
    };
  };
};
